// import Swiper from 'swiper'

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.lp-section__wrapper')
  const swiper = new Swiper('.lp-section__wrapper', {
    slidesPerView: 'auto',
    spaceBetween: 150,
    initialSlide: Math.floor(document.querySelectorAll('.swiper-slide').length / 2),
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    speed: 800,
    direction: 'horizontal',
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    updateOnImagesReady: true,
    on: {
      imagesReady: function () {
        this.update()
      }
    }
  })
})
